// src/constants/tokenData.js
export const TOKEN_NAMES = {
  // Mainnet tokens
  "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2": "WETH",
  "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599": "WBTC",
  "0x514910771AF9Ca656af840dff83E8264EcF986CA": "LINK",
  "0x4206931337dc273a630d328dA6441786BfaD668f": "DOGE",
  "0x39fBBABf11738317a448031930706cd3e612e1B9": "WXRP",
  
  // Additional common mainnet tokens for reference
  "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48": "USDC",
  "0xdAC17F958D2ee523a2206206994597C13D831ec7": "USDT",
  "0x6B175474E89094C44Da98b954EedeAC495271d0F": "DAI",
  "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0": "MATIC",
  "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984": "UNI",
  "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e": "YFI",
  "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9": "AAVE",
  "0x4d224452801ACEd8B2F0aebE155379bb5D594381": "APE",
  
  // Keep Sepolia tokens for reference
  "sepolia:0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9": "WETH (Sepolia)",
  "sepolia:0x779877A7B0D9E8603169DdbD7836e478b4624789": "LINK (Sepolia)"
};